import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Loading = ({ center, absolute, white, inherit }) => {
    const getClassMainElement = () => {
        return classNames({
            'loading': true,
            'loading_center': center,
            'loading_absolute': absolute,
            'loading_white': white,
            'loading_inherit': inherit
        });
    };

    return (
        <div className={getClassMainElement()}>
            <div className="loading__bounce loading__bounce_1" />
            <div className="loading__bounce loading__bounce_2" />
        </div>
    );
};

Loading.propTypes = {
    center: PropTypes.bool,
    absolute: PropTypes.bool,
    white: PropTypes.bool,
    inherit: PropTypes.bool
};

Loading.defaultProps = {
    center: false,
    absolute: false,
    white: false,
    inherit: false
};

export default Loading;
